export const path = {
  messages: {
    route: "/messages",
    link: () => path.messages.route,
  },
};
